module.exports = __webpack_public_path__ + "assets/img/d1f6503da96eb95557c74f7959538996.svg";